module.exports = __webpack_public_path__ + "static/media/florida.2cb37424.jpeg";